<!-- Los estilos viven en src/assets/styles/components/_documento-carga.scss (ver el .scss del componente). -->
<section class="doc-carga" lang="es" [class.doc-carga--multi]="esMultiarchivo" [class.is-terminado]="terminado">
  <p class="doc-sr" role="status" aria-live="polite">{{anuncio}}</p>

  <!-- Encabezado: qué se pide y cuánto falta -->
  <header class="doc-hero">
    <div class="doc-hero__cabeza">
      <span class="doc-hero__icono" aria-hidden="true"><fa-icon [icon]="iconos.documento"></fa-icon></span>
      <div class="doc-hero__textos">
        <h2 class="doc-hero__titulo">{{titulo}}</h2>
        <p class="doc-hero__subtitulo" *ngIf="subtitulo">{{subtitulo}}</p>
        <span *ngIf="(!esMultiarchivo || unaSola) && !eligiendoIdentificacion" class="doc-chip doc-chip--{{estadoUnicoVisual}}">{{textoEstadoUnico}}</span>
        <!-- Paso opcional del flujo: se puede omitir; regresa a la lista sin subir nada -->
        <ng-container *ngIf="data.opcional && !terminado">
          <span class="doc-tarjeta__opcional doc-hero__opcional" data-test="hero-opcional">Opcional</span>
          <button type="button" class="doc-enlace doc-hero__omitir" [disabled]="ocupado" (click)="continuar()" data-test="omitir">
            <span>Omitir por ahora</span><fa-icon [icon]="iconos.siguiente" aria-hidden="true"></fa-icon>
          </button>
        </ng-container>
      </div>
    </div>
    <div class="doc-avance" *ngIf="esMultiarchivo && !unaSola && !eligiendoIdentificacion">
      <div class="doc-avance__fila">
        <span class="doc-avance__texto"><strong>{{avanceFuerte}}</strong> {{avanceResto}}</span>
        <span class="doc-avance__pct">{{porcentajeAvance}} %</span>
      </div>
      <!-- Con rango («de 4 a 6») la barra se llena con el mínimo -->
      <div class="doc-avance__barra" role="progressbar" aria-label="Avance de tus documentos" aria-valuemin="0"
           [attr.aria-valuemax]="metaAvance" [attr.aria-valuenow]="valorAvance"
           [attr.aria-valuetext]="avanceFuerte + ' ' + avanceResto">
        <span class="doc-avance__relleno" [style.width.%]="porcentajeAvance"></span>
      </div>
    </div>
  </header>

  <!-- Rechazo del paso: amable, con el motivo -->
  <div class="doc-aviso doc-aviso--rechazo" *ngIf="data.comment && !terminado && !identificacionCambiada">
    <span class="doc-aviso__icono" aria-hidden="true"><fa-icon [icon]="iconos.reintentar"></fa-icon></span>
    <div class="doc-aviso__cuerpo">
      <p class="doc-aviso__titulo">Necesitamos que lo vuelvas a subir</p>
      <p class="doc-aviso__texto">Motivo: <strong>{{data.comment}}</strong></p>
    </div>
  </div>

  <!-- Documento para descargar y firmar (InputCatalog.settings.downloadUrl), p. ej. términos y condiciones -->
  <div class="doc-aviso" *ngIf="downloadUrl && !terminado">
    <span class="doc-aviso__icono" aria-hidden="true"><fa-icon [icon]="iconos.descargar"></fa-icon></span>
    <div class="doc-aviso__cuerpo">
      <p class="doc-aviso__titulo">Descárgalo, fírmalo y vuelve a subirlo aquí</p>
      <button type="button" class="doc-boton doc-boton--secundario doc-boton--chico" (click)="download()">Descargar documento</button>
    </div>
  </div>

  <!-- Paso completo: celebración -->
  <div class="doc-celebracion" *ngIf="terminado">
    <div class="doc-celebracion__check">
      <span class="doc-confeti" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i><i></i><i></i></span>
      <svg class="doc-check" viewBox="0 0 52 52" aria-hidden="true">
        <circle class="doc-check__circulo" cx="26" cy="26" r="25"></circle>
        <path class="doc-check__trazo" d="M15 27.5l7 7 15-16"></path>
      </svg>
    </div>
    <h3 class="doc-celebracion__titulo">{{tituloListo}}</h3>
    <p class="doc-celebracion__msg" *ngIf="mensajeExito">{{mensajeExito}}</p>
    <button type="button" class="doc-boton doc-boton--primario" (click)="continuar()">Continuar</button>
    <p class="doc-celebracion__nota">Te regresamos a tus pasos en unos segundos.</p>
  </div>

  <!-- Documento de identidad (Omnicanal: settings.identificaciones): cuál va a subir -->
  <div class="doc-identidad" *ngIf="eligiendoIdentificacion">
    <ng-container *ngIf="!cambioPendiente; else confirmarCambio">
      <h3 class="doc-identidad__titulo" id="doc-identidad-titulo" tabindex="-1" #refSelector>¿Qué identificación vas a subir?</h3>
      <p class="doc-identidad__sub">Elige una y te pedimos solo lo de esa.</p>
      <div class="doc-identidad__opciones" role="group" aria-labelledby="doc-identidad-titulo">
        <button type="button" class="doc-identidad__opcion" *ngFor="let opcion of opcionesIdentificacion; trackBy: porClave"
                [class.is-actual]="opcion.clave === identificacionActual"
                [attr.aria-current]="opcion.clave === identificacionActual ? 'true' : null"
                [attr.aria-describedby]="'doc-identidad-pide-' + opcion.clave"
                [disabled]="ocupado" (click)="elegirIdentificacion(opcion.clave)">
          <span class="doc-identidad__icono" aria-hidden="true"><fa-icon [icon]="opcion.icono"></fa-icon></span>
          <span class="doc-identidad__textos">
            <span class="doc-identidad__nombre">{{opcion.nombre}}</span>
            <span class="doc-identidad__pide" [id]="'doc-identidad-pide-' + opcion.clave">{{opcion.pide}}</span>
          </span>
          <span class="doc-identidad__actual" *ngIf="opcion.clave === identificacionActual">La que elegiste</span>
          <span class="doc-identidad__flecha" aria-hidden="true"><fa-icon [icon]="iconos.siguiente"></fa-icon></span>
        </button>
      </div>
      <button type="button" class="doc-enlace doc-identidad__volver" *ngIf="cambiandoIdentificacion && identificacion"
              (click)="cerrarCambioIdentificacion()">Seguir con mi {{nombreDe(identificacion)}}</button>
    </ng-container>

    <!-- Ya hay archivos de la otra: se confirma aquí mismo (sin ventanas del navegador) -->
    <ng-template #confirmarCambio>
      <div class="doc-confirmar" role="group" aria-labelledby="doc-confirmar-titulo" aria-describedby="doc-confirmar-texto">
        <span class="doc-confirmar__icono" aria-hidden="true"><fa-icon [icon]="iconos.cambiar"></fa-icon></span>
        <h3 class="doc-confirmar__titulo" id="doc-confirmar-titulo" tabindex="-1" #refConfirmar>¿Cambias a {{nombreDe(cambioPendiente)}}?</h3>
        <p class="doc-confirmar__texto" id="doc-confirmar-texto">{{textoConfirmarCambio}}</p>
        <div class="doc-confirmar__acciones">
          <button type="button" class="doc-boton doc-boton--primario doc-boton--chico doc-confirmar__si" [disabled]="ocupado"
                  (click)="confirmarCambioIdentificacion()">Sí, cambiar a {{nombreDe(cambioPendiente)}}</button>
          <button type="button" class="doc-boton doc-boton--secundario doc-boton--chico doc-confirmar__no"
                  (click)="cancelarCambioIdentificacion()">Seguir con mi {{nombreDe(identificacionActual)}}</button>
        </div>
      </div>
    </ng-template>
  </div>

  <ng-container *ngIf="!terminado && !eligiendoIdentificacion">
    <!-- La identificación elegida, con «Cambiar identificación» -->
    <div class="doc-identidad-elegida" *ngIf="mostrarIdentificacion">
      <span class="doc-identidad-elegida__icono" aria-hidden="true"><fa-icon [icon]="iconoIdentificacion"></fa-icon></span>
      <p class="doc-identidad-elegida__texto" tabindex="-1" #refIdentidad>Vas a subir tu <strong>{{nombreDe(identificacion)}}</strong></p>
      <button type="button" class="doc-enlace doc-identidad-elegida__cambiar" [disabled]="ocupado" (click)="abrirCambioIdentificacion()">
        <fa-icon [icon]="iconos.cambiar"></fa-icon><span>Cambiar identificación</span>
      </button>
    </div>

    <!-- Multiarchivo: una tarjeta por archivo; la activa es el destino de la zona de carga -->
    <div class="doc-bloque" *ngIf="esMultiarchivo && !unaSola">
      <p class="doc-seccion" id="doc-seccion-tarjetas">Elige qué {{sustantivo}} vas a subir</p>
      <!-- Rango: con el mínimo ya pasa; las tarjetas después del mínimo dicen «Opcional» -->
      <p class="doc-rango" id="doc-rango" *ngIf="tieneRango">
        <fa-icon [icon]="iconos.info" aria-hidden="true"></fa-icon><span>{{textoRango}}</span>
      </p>
      <div class="doc-tarjetas" role="group" aria-labelledby="doc-seccion-tarjetas" [attr.aria-describedby]="tieneRango ? 'doc-rango' : null"
           [class.doc-tarjetas--pocas]="renglones.length < 4" [class.doc-tarjetas--cuatro]="renglones.length === 4"
           [class.doc-tarjetas--tres]="renglones.length === 5 || renglones.length === 6 || renglones.length === 9"
           [style.--columnas]="renglones.length">
        <button type="button" class="doc-tarjeta" *ngFor="let renglon of renglones; trackBy: porIndice"
                [class.is-listo]="renglon.estado === 'CARGADO'"
                [class.is-rechazado]="renglon.estado === 'RECHAZADO'"
                [class.is-elegido]="!!renglon.archivo"
                [class.is-error]="!!renglon.archivo && !!renglon.errorSubida"
                [class.is-activo]="renglon.index === tarjetaResaltada"
                [class.is-opcional]="esOpcional(renglon)"
                [attr.aria-pressed]="renglon.index === tarjetaResaltada"
                [attr.aria-label]="etiquetaTarjeta(renglon)"
                [disabled]="ocupado"
                (click)="seleccionarTarjeta(renglon)">
          <span class="doc-tarjeta__icono" [class.is-pdf]="esPdfTarjeta(renglon)" [class.is-miniatura]="!!miniaturaTarjeta(renglon)" aria-hidden="true">
            <img *ngIf="miniaturaTarjeta(renglon) as miniatura; else iconoDeTarjeta" [src]="miniatura" alt="">
            <ng-template #iconoDeTarjeta><fa-icon [icon]="iconoTarjeta(renglon)"></fa-icon></ng-template>
          </span>
          <span class="doc-tarjeta__etiqueta">{{renglon.etiqueta}}</span>
          <span class="doc-tarjeta__archivo" *ngIf="renglon.archivo">{{renglon.archivo.name}}</span>
          <span class="doc-tarjeta__estado">{{textoEstado(renglon)}}</span>
          <span class="doc-tarjeta__opcional" *ngIf="esOpcional(renglon)" aria-hidden="true">Opcional</span>
          <span class="doc-tarjeta__insignia" *ngIf="renglon.estado !== 'PENDIENTE'" aria-hidden="true">
            <fa-icon [icon]="renglon.estado === 'CARGADO' ? iconos.listo : iconos.alerta"></fa-icon>
          </span>
        </button>
      </div>
    </div>

    <div class="doc-area" #areaCarga>
      <!-- Rango: ya están los necesarios y quedan opcionales; no regresa solo -->
      <div class="doc-exito doc-exito--minimo" *ngIf="completoMinimo && !colaActiva">
        <svg class="doc-check" viewBox="0 0 52 52" aria-hidden="true">
          <circle class="doc-check__circulo" cx="26" cy="26" r="25"></circle>
          <path class="doc-check__trazo" d="M15 27.5l7 7 15-16"></path>
        </svg>
        <div class="doc-exito__cuerpo">
          <p class="doc-exito__titulo">{{tituloCompletoMinimo}}</p>
          <p class="doc-exito__texto">{{textoCompletoMinimo}}</p>
          <button type="button" class="doc-boton doc-boton--primario doc-boton--chico doc-exito__continuar" [disabled]="ocupado" (click)="continuar()">Continuar</button>
        </div>
      </div>

      <!-- Se guardó uno y aún faltan (con varios, lo dice el resumen de la cola) -->
      <div class="doc-exito" *ngIf="mensajeExito && !cola.length && !completoMinimo">
        <svg class="doc-check" viewBox="0 0 52 52" aria-hidden="true">
          <circle class="doc-check__circulo" cx="26" cy="26" r="25"></circle>
          <path class="doc-check__trazo" d="M15 27.5l7 7 15-16"></path>
        </svg>
        <div class="doc-exito__cuerpo">
          <p class="doc-exito__titulo">¡Se guardó!</p>
          <p class="doc-exito__texto">{{mensajeExito}}</p>
        </div>
      </div>

      <!-- Motivo del archivo rechazado que está seleccionado, mientras elige el
           nuevo; ya elegido, el motivo sigue en «Tus documentos» y aquí no se
           amontona con la vista previa, la subida o un error. -->
      <div class="doc-nota-rechazo" *ngIf="esMultiarchivo && activo.estado === 'RECHAZADO' && !activo.archivo && !colaActiva">
        <span class="doc-nota-rechazo__icono" aria-hidden="true"><fa-icon [icon]="iconos.alerta"></fa-icon></span>
        <div>
          <p class="doc-nota-rechazo__titulo">Vuelve a subir «{{activo.etiqueta}}»</p>
          <p class="doc-nota-rechazo__texto" *ngIf="activo.comentario">Motivo: <strong>{{activo.comentario}}</strong></p>
        </div>
      </div>

      <!-- Tamaño o tipo que no pasan: aviso en línea -->
      <div class="doc-aviso doc-aviso--validacion" *ngIf="avisoValidacion">
        <span class="doc-aviso__icono" aria-hidden="true"><fa-icon [icon]="iconos.alerta"></fa-icon></span>
        <p class="doc-aviso__texto">{{avisoValidacion}}</p>
        <button type="button" class="doc-cerrar" aria-label="Cerrar aviso" (click)="avisoValidacion = ''">
          <fa-icon [icon]="iconos.cerrar"></fa-icon>
        </button>
      </div>

      <!-- Varios a la vez: los que no sirven no se asignan (y no frenan a los demás) -->
      <div class="doc-aviso doc-aviso--validacion doc-aviso--lista" *ngIf="archivosDescartados.length">
        <span class="doc-aviso__icono" aria-hidden="true"><fa-icon [icon]="iconos.alerta"></fa-icon></span>
        <div class="doc-aviso__cuerpo">
          <p class="doc-aviso__titulo">{{tituloDescartados}}</p>
          <ul class="doc-aviso__items">
            <li *ngFor="let descartado of archivosDescartados"><strong>{{descartado.nombre}}</strong>: {{descartado.motivo}}.</li>
          </ul>
        </div>
        <button type="button" class="doc-cerrar" aria-label="Cerrar aviso" (click)="archivosDescartados = []">
          <fa-icon [icon]="iconos.cerrar"></fa-icon>
        </button>
      </div>

      <!-- Varios a la vez: eligió más de los que faltan -->
      <div class="doc-aviso doc-aviso--info" *ngIf="avisoSobrantes as aviso">
        <span class="doc-aviso__icono" aria-hidden="true"><fa-icon [icon]="iconos.info"></fa-icon></span>
        <div class="doc-aviso__cuerpo">
          <p class="doc-aviso__titulo">{{aviso.titulo}}</p>
          <p class="doc-aviso__texto">{{aviso.texto}}</p>
        </div>
        <button type="button" class="doc-cerrar" aria-label="Cerrar aviso" (click)="avisoSobrantes = null">
          <fa-icon [icon]="iconos.cerrar"></fa-icon>
        </button>
      </div>

      <!-- Varios a la vez: lo elegido en orden, la cola de subida y su resumen -->
      <section class="doc-lote" *ngIf="mostrarLote" [class.is-subiendo]="colaActiva" aria-labelledby="doc-lote-titulo">
        <div class="doc-lote__cabeza">
          <h3 class="doc-lote__titulo" id="doc-lote-titulo" tabindex="-1" #refTitulo>{{tituloLote}}</h3>
          <p class="doc-lote__sub" *ngIf="subtituloLote">{{subtituloLote}}</p>
        </div>

        <div class="doc-cola" *ngIf="cola.length" role="progressbar" aria-label="Avance de tus archivos" aria-valuemin="0"
             [attr.aria-valuemax]="cola.length" [attr.aria-valuenow]="colaHechos" [attr.aria-valuetext]="tituloLote">
          <span class="doc-cola__segmento is-{{item.estado}}" *ngFor="let item of cola; trackBy: porIndice"></span>
        </div>

        <ol class="doc-lote__lista">
          <li class="doc-lote__item is-{{fila.estado}}" *ngFor="let fila of filasLote; trackBy: porIndice"
              [id]="'doc-lote-fila-' + fila.index" [class.is-abierta]="edicion === fila.index && puedeEditar(fila)">
            <button type="button" class="doc-lote__fila" *ngIf="puedeEditar(fila); else filaFija"
                    [attr.aria-expanded]="edicion === fila.index" [attr.aria-controls]="'doc-lote-acciones-' + fila.index"
                    (click)="editarFila(fila.index)">
              <ng-container *ngTemplateOutlet="contenidoFila; context: {$implicit: fila}"></ng-container>
              <span class="doc-lote__abrir" aria-hidden="true"><fa-icon [icon]="iconos.abrir"></fa-icon></span>
              <span class="doc-sr">. Toca para cambiarlo o quitarlo</span>
            </button>
            <ng-template #filaFija>
              <div class="doc-lote__fila">
                <ng-container *ngTemplateOutlet="contenidoFila; context: {$implicit: fila}"></ng-container>
              </div>
            </ng-template>
            <div class="doc-lote__acciones" [id]="'doc-lote-acciones-' + fila.index"
                 *ngIf="puedeReintentar(fila) || (edicion === fila.index && puedeEditar(fila))">
              <button type="button" class="doc-boton doc-boton--secundario doc-boton--chico doc-lote__reintentar" *ngIf="puedeReintentar(fila)"
                      [attr.aria-label]="'Reintentar ' + fila.etiqueta" (click)="reintentarFila(fila.index)">
                <fa-icon [icon]="iconos.reintentar"></fa-icon><span>Reintentar</span>
              </button>
              <ng-container *ngIf="edicion === fila.index && puedeEditar(fila)">
                <button type="button" class="doc-boton doc-boton--secundario doc-boton--chico doc-lote__cambiar"
                        [attr.aria-label]="'Cambiar el archivo de ' + fila.etiqueta" (click)="cambiarArchivo(fila.index)">
                  <fa-icon [icon]="iconos.carpeta"></fa-icon><span>Cambiar</span>
                </button>
                <button type="button" class="doc-boton doc-boton--quitar doc-boton--chico doc-lote__quitar"
                        [attr.aria-label]="'Quitar el archivo de ' + fila.etiqueta" (click)="quitarDeLote(fila.index)">
                  <fa-icon [icon]="iconos.borrar"></fa-icon><span>Quitar</span>
                </button>
              </ng-container>
            </div>
          </li>
        </ol>

        <div class="doc-lote__pie">
          <ng-container *ngIf="colaActiva; else pieSeleccion">
            <button type="button" class="doc-boton doc-boton--secundario doc-lote__cancelar" #refAccion *ngIf="colaEnEspera || cancelando"
                    [class.is-esperando]="cancelando" [attr.aria-disabled]="cancelando ? 'true' : null" (click)="cancelarCola()">
              <fa-icon [icon]="iconos.cerrar" *ngIf="!cancelando"></fa-icon><span>{{textoCancelar}}</span>
            </button>
          </ng-container>
          <ng-template #pieSeleccion>
            <button type="button" class="doc-boton doc-boton--primario doc-lote__subir" #refAccion *ngIf="textoBotonLote"
                    (click)="cola.length ? reanudarCola() : subirSeleccion()">
              <fa-icon [icon]="cola.length && soloErrores ? iconos.reintentar : iconos.subir"></fa-icon><span>{{textoBotonLote}}</span>
            </button>
            <button type="button" class="doc-enlace doc-lote__agregar" *ngIf="puedeAgregar" (click)="reglasCarga.conArchivo ? inputArchivo.click() : abrirCamara()">
              <fa-icon [icon]="iconos.agregar"></fa-icon><span>{{textoAgregar}}</span>
            </button>
          </ng-template>
        </div>
      </section>

      <!-- Un archivo elegido: vista previa, subida y error -->
      <div class="doc-elegido" *ngIf="mostrarElegido && activo.archivo as archivo" [class.is-subiendo]="subiendo" [class.is-error]="!!activo.errorSubida && !subiendo">
        <div class="doc-elegido__fila">
          <div class="doc-miniatura" [class.is-pdf]="tipoDe(archivo) === 'pdf'" [class.is-escaneando]="analizando">
            <img *ngIf="activo.vistaPrevia; else iconoElegido" [src]="activo.vistaPrevia" alt="Vista previa del archivo elegido">
            <ng-template #iconoElegido>
              <fa-icon [icon]="iconoTipo(tipoDe(archivo))"></fa-icon>
              <span>{{tipoDe(archivo) === 'pdf' ? 'PDF' : 'Archivo'}}</span>
            </ng-template>
          </div>
          <div class="doc-elegido__info">
            <p class="doc-elegido__para" *ngIf="esMultiarchivo">{{sustantivo | titlecase}} «{{activo.etiqueta}}»</p>
            <p class="doc-elegido__nombre" [title]="archivo.name">{{archivo.name}}</p>
            <p class="doc-elegido__meta">{{tamanoTexto(archivo.size)}} · {{tipoDe(archivo) === 'pdf' ? 'PDF' : 'Imagen'}}</p>
          </div>
          <button type="button" class="doc-icono-boton" *ngIf="!subiendo" aria-label="Quitar archivo" (click)="quitarArchivo(activo)">
            <fa-icon [icon]="iconos.borrar"></fa-icon>
          </button>
        </div>

        <div class="doc-progreso" *ngIf="subiendo">
          <div class="doc-progreso__fila">
            <span>{{analizando ? 'Analizando tu documento…' : 'Subiendo tu documento…'}}</span>
            <span class="doc-progreso__pct" *ngIf="!analizando">{{progreso}} %</span>
          </div>
          <div class="doc-progreso__barra" [class.is-indeterminada]="analizando" role="progressbar"
               aria-label="Avance de la subida" aria-valuemin="0" aria-valuemax="100"
               [attr.aria-valuenow]="analizando ? null : progreso">
            <span class="doc-progreso__relleno" [style.width.%]="analizando ? null : progreso"></span>
          </div>
          <p class="doc-progreso__nota" *ngIf="analizando">Revisamos que se lea bien; puede tardar hasta un minuto. No cierres esta pantalla.</p>
        </div>

        <div class="doc-error" *ngIf="activo.errorSubida && !subiendo">
          <span class="doc-error__icono" aria-hidden="true"><fa-icon [icon]="iconos.alerta"></fa-icon></span>
          <p>{{activo.errorSubida}}</p>
        </div>

        <ng-container *ngIf="!subiendo">
          <button type="button" class="doc-boton doc-boton--primario" *ngIf="activo.errorSubida; else botonSubir" (click)="reintentar()">
            <fa-icon [icon]="iconos.reintentar"></fa-icon><span>Reintentar</span>
          </button>
          <ng-template #botonSubir>
            <button type="button" class="doc-boton doc-boton--primario" (click)="subirActivo()">
              <fa-icon [icon]="iconos.subir"></fa-icon><span>{{textoBotonSubir}}</span>
            </button>
          </ng-template>
          <button type="button" class="doc-enlace doc-elegido__agregar" *ngIf="puedeAgregar" (click)="reglasCarga.conArchivo ? inputArchivo.click() : abrirCamara()">
            <fa-icon [icon]="iconos.agregar"></fa-icon><span>{{textoAgregar}}</span>
          </button>
        </ng-container>
      </div>

      <!-- Zona grande: tocar, tomar foto o arrastrar (en multiarchivo, varios a la vez) -->
      <ng-container *ngIf="mostrarZona">
        <div class="doc-zona" [class.is-arrastrando]="arrastrando" [class.is-bloqueada]="subiendo"
             (dragenter)="alArrastrar($event)" (dragover)="alArrastrar($event)"
             (dragleave)="alSalirArrastre($event)" (drop)="alSoltar($event)">
          <button type="button" class="doc-zona__principal" #refZona [disabled]="subiendo" (click)="reglasCarga.conArchivo ? inputArchivo.click() : abrirCamara()">
            <span class="doc-nube" aria-hidden="true">
              <span class="doc-nube__halo"></span>
              <svg class="doc-nube__ilustracion" viewBox="0 0 96 96">
                <defs>
                  <linearGradient id="doc-nube-degradado" x1="0" y1="0" x2="1" y2="1">
                    <stop offset="0" stop-color="#8587F8"></stop>
                    <stop offset="1" stop-color="#5D5FEF"></stop>
                  </linearGradient>
                </defs>
                <path d="M28 68a14 14 0 0 1-1.6-27.9 20 20 0 0 1 38.2-5.6A17.5 17.5 0 0 1 68 68z" fill="url(#doc-nube-degradado)"></path>
                <path d="M48 60V43M40 50.5 48 42.5l8 8" fill="none" stroke="#fff" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
              <i class="doc-destello doc-destello--1"><svg viewBox="0 0 10 10"><path d="M5 0 6.2 3.8 10 5 6.2 6.2 5 10 3.8 6.2 0 5 3.8 3.8Z"></path></svg></i>
              <i class="doc-destello doc-destello--2"><svg viewBox="0 0 10 10"><path d="M5 0 6.2 3.8 10 5 6.2 6.2 5 10 3.8 6.2 0 5 3.8 3.8Z"></path></svg></i>
              <i class="doc-destello doc-destello--3"><svg viewBox="0 0 10 10"><path d="M5 0 6.2 3.8 10 5 6.2 6.2 5 10 3.8 6.2 0 5 3.8 3.8Z"></path></svg></i>
              <i class="doc-destello doc-destello--4"><svg viewBox="0 0 10 10"><path d="M5 0 6.2 3.8 10 5 6.2 6.2 5 10 3.8 6.2 0 5 3.8 3.8Z"></path></svg></i>
            </span>
            <span class="doc-zona__titulo">{{tituloZona}}</span>
            <span class="doc-zona__sub">{{subtituloZona}}</span>
            <span class="doc-zona__formatos">{{formatos}} · máx. {{tamanoMaximoTexto}}</span>
          </button>
          <div class="doc-zona__accesos">
            <button type="button" class="doc-acceso doc-acceso--camara" *ngIf="reglasCarga.conCamara" [disabled]="subiendo" (click)="abrirCamara()">
              <fa-icon [icon]="iconos.camara"></fa-icon><span>Tomar foto</span>
            </button>
            <button type="button" class="doc-acceso doc-acceso--archivo" *ngIf="reglasCarga.conArchivo" [disabled]="subiendo" (click)="inputArchivo.click()">
              <fa-icon [icon]="iconos.carpeta"></fa-icon><span>{{textoElegirArchivos}}</span>
            </button>
          </div>
        </div>
        <p class="doc-consejo">
          <fa-icon [icon]="iconos.consejo" aria-hidden="true"></fa-icon>
          <span>Que se vea completo, nítido y sin reflejos.</span>
        </p>
      </ng-container>

      <!-- Inputs nativos ocultos: «Tomar foto» es de uno (para la tarjeta activa);
           «Elegir archivos» acepta varios en multiarchivo; «Cambiar» es de uno. -->
      <input #inputCamara class="doc-oculto doc-input-camara" type="file" [attr.accept]="acceptCamara" capture="environment"
             tabindex="-1" aria-hidden="true" (change)="alElegir($event)">
      <input #inputArchivo class="doc-oculto doc-input-archivo" type="file" [attr.accept]="acceptArchivo"
             [attr.multiple]="esMultiarchivo && !unaSola ? '' : null" tabindex="-1" aria-hidden="true" (change)="alElegir($event)">
      <input #refReemplazo class="doc-oculto doc-input-reemplazo" type="file" *ngIf="esMultiarchivo"
             [attr.accept]="reglasCarga.conArchivo ? acceptArchivo : acceptCamara" [attr.capture]="reglasCarga.conArchivo ? null : 'environment'"
             tabindex="-1" aria-hidden="true" (change)="alReemplazar($event)">

      <!-- Cámara con recuadro (Omnicanal: settings.guia; en identidad, el de la elegida); se monta en <body> a pantalla completa. -->
      <app-camara-guia *ngIf="camaraGuia && guiaCamara as recuadro" [guia]="recuadro" [titulo]="tituloCamara"
                       [etiqueta]="camaraGuia.etiqueta" [tipo]="tipoFotoCamara"
                       (capturar)="alFotoDeCamara($event)" (cerrar)="camaraGuia = null"
                       (usarCamaraDelEquipo)="alCamaraDelEquipo()"></app-camara-guia>
    </div>
  </ng-container>

  <!-- Lo que ya está cargado -->
  <section class="doc-lista" *ngIf="documentosCargados.length && !eligiendoIdentificacion" aria-labelledby="doc-lista-titulo">
    <div class="doc-lista__cabeza">
      <h3 id="doc-lista-titulo">Tus documentos</h3>
      <span class="doc-chip doc-chip--suave" *ngIf="esMultiarchivo && !unaSola">{{archivosCargados}}/{{renglones.length}} cargados</span>
    </div>
    <ul class="doc-lista__filas">
      <li class="doc-fila" *ngFor="let renglon of documentosCargados; trackBy: porIndice" [class.is-rechazado]="renglon.estado === 'RECHAZADO'">
        <span class="doc-fila__icono" [class.is-pdf]="tipoFila(renglon) === 'pdf'" aria-hidden="true">
          <img *ngIf="renglon.subido?.miniatura; else iconoFila" [src]="renglon.subido?.miniatura" alt="">
          <ng-template #iconoFila><fa-icon [icon]="iconoTipo(tipoFila(renglon))"></fa-icon></ng-template>
        </span>
        <div class="doc-fila__info">
          <p class="doc-fila__titulo">{{esMultiarchivo ? renglon.etiqueta : titulo}}</p>
          <p class="doc-fila__meta">{{metaFila(renglon)}}</p>
          <p class="doc-fila__motivo" *ngIf="esMultiarchivo && renglon.estado === 'RECHAZADO' && renglon.comentario">Motivo: {{renglon.comentario}}</p>
          <div class="doc-fila__pie">
            <span class="doc-chip" [class.doc-chip--listo]="renglon.estado === 'CARGADO'" [class.doc-chip--rechazado]="renglon.estado === 'RECHAZADO'">
              {{renglon.estado === 'CARGADO' ? 'Cargado' : 'Rechazado'}}
            </span>
            <button type="button" class="doc-enlace" *ngIf="!terminado" [disabled]="ocupado" (click)="reemplazar(renglon)"
                    [attr.aria-label]="'Reemplazar ' + (esMultiarchivo ? renglon.etiqueta : titulo)">
              <fa-icon [icon]="iconos.reintentar"></fa-icon><span>Reemplazar</span>
            </button>
          </div>
        </div>
      </li>
    </ul>
  </section>

  <p class="doc-seguro">
    <span class="doc-seguro__icono" aria-hidden="true"><fa-icon [icon]="iconos.seguro"></fa-icon></span>
    <span>Tus documentos se envían de forma segura y solo se usan para validar tu solicitud.</span>
  </p>
</section>

<!-- Contenido de un renglón del resumen (dentro de un <button>: solo <span>) -->
<ng-template #contenidoFila let-fila>
  <span class="doc-lote__miniatura" [class.is-pdf]="fila.tipo === 'pdf'" [class.is-escaneando]="fila.estado === 'subiendo' && analizando"
        [class.is-marcada]="fila.estado === 'guardado' || fila.estado === 'error'" aria-hidden="true">
    <img *ngIf="fila.miniatura; else iconoDeFila" [src]="fila.miniatura" alt="">
    <ng-template #iconoDeFila><fa-icon [icon]="iconoTipo(fila.tipo)"></fa-icon></ng-template>
    <span class="doc-lote__marca" *ngIf="fila.estado === 'guardado' || fila.estado === 'error'">
      <fa-icon [icon]="fila.estado === 'guardado' ? iconos.listo : iconos.alerta"></fa-icon>
    </span>
  </span>
  <span class="doc-lote__info">
    <span class="doc-lote__etiqueta">{{fila.etiqueta}}</span>
    <span class="doc-lote__nombre"><span class="doc-lote__archivo">{{fila.nombre}}</span><span class="doc-lote__tamano">· {{tamanoTexto(fila.tamano)}}</span></span>
    <span class="doc-lote__estado">{{textoFila(fila)}}</span>
    <span class="doc-lote__barra" *ngIf="fila.estado === 'subiendo'" [class.is-indeterminada]="analizando" role="progressbar"
          [attr.aria-label]="'Avance de ' + fila.etiqueta" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="analizando ? null : progreso">
      <span class="doc-lote__relleno" [style.width.%]="analizando ? null : progreso"></span>
    </span>
    <span class="doc-lote__error" *ngIf="fila.error">{{fila.error}}</span>
  </span>
</ng-template>
